import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateJobSeekerProfileLocationMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileInput;
}>;


export type UpdateJobSeekerProfileLocationMutation = { __typename?: 'Mutation', updateJobSeekerProfile?: { __typename?: 'UpdateJobSeekerProfilePayload', profile?: { __typename?: 'JobSeekerProfile', accountKey?: string | null, defaultInfo?: { __typename?: 'JobSeekerProfileDefaultInfo', contactInformation?: { __typename?: 'JobSeekerProfileContactInformation', location?: { __typename?: 'JobSeekerProfileLocationType', address?: string | null, admin1?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, formattedLocation?: string | null, latitude?: number | null, longitude?: number | null, geocodePrecision?: Types.JobSeekerProfileGeocodePrecision | null } | null } | null } | null } | null } | null };


export const UpdateJobSeekerProfileLocationDocument = gql`
    mutation UpdateJobSeekerProfileLocation($input: UpdateJobSeekerProfileInput!) {
  updateJobSeekerProfile(input: $input) {
    profile {
      accountKey
      defaultInfo {
        contactInformation {
          location {
            address
            admin1
            city
            country
            state
            postalCode
            formattedLocation
            latitude
            longitude
            geocodePrecision
          }
        }
      }
    }
  }
}
    `;
export type UpdateJobSeekerProfileLocationMutationFn = Apollo.MutationFunction<UpdateJobSeekerProfileLocationMutation, UpdateJobSeekerProfileLocationMutationVariables>;

/**
 * __useUpdateJobSeekerProfileLocationMutation__
 *
 * To run a mutation, you first call `useUpdateJobSeekerProfileLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobSeekerProfileLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobSeekerProfileLocationMutation, { data, loading, error }] = useUpdateJobSeekerProfileLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobSeekerProfileLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobSeekerProfileLocationMutation, UpdateJobSeekerProfileLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobSeekerProfileLocationMutation, UpdateJobSeekerProfileLocationMutationVariables>(UpdateJobSeekerProfileLocationDocument, options);
      }
export type UpdateJobSeekerProfileLocationMutationHookResult = ReturnType<typeof useUpdateJobSeekerProfileLocationMutation>;
export type UpdateJobSeekerProfileLocationMutationResult = Apollo.MutationResult<UpdateJobSeekerProfileLocationMutation>;
export type UpdateJobSeekerProfileLocationMutationOptions = Apollo.BaseMutationOptions<UpdateJobSeekerProfileLocationMutation, UpdateJobSeekerProfileLocationMutationVariables>;